import type { Module } from 'vuex';
import { actions } from './actions';

const ConsultationStore: Module<{}, {}> = {
  actions,
};

export default ConsultationStore;